import type { ReactNode } from "react";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  tone?: "danger" | "primary";
  onConfirm: () => void;
  onCancel: () => void;
  children?: ReactNode;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "تأكيد",
  tone = "danger",
  onConfirm,
  onCancel,
  children,
}: ConfirmDialogProps) {
  if (!open) return null;

  const confirmClass =
    tone === "danger"
      ? "bg-red-500 hover:bg-red-600 text-white"
      : "bg-primary-500 hover:bg-primary-600 text-white";

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground-950/40 yc-fade-in"
        onClick={onCancel}
        aria-hidden="true"
      ></div>
      <div className="relative z-10 w-full max-w-sm yc-pop bg-white rounded-card border border-background-200 shadow-pop p-6 text-center">
        <div
          className={`mx-auto w-14 h-14 flex items-center justify-center rounded-full text-2xl mb-4 ${
            tone === "danger"
              ? "bg-red-100 text-red-500"
              : "bg-primary-100 text-primary-600"
          }`}
        >
          <i
            className={
              tone === "danger" ? "ri-alert-line" : "ri-question-line"
            }
          ></i>
        </div>
        <h3 className="text-lg font-bold text-foreground-950">{title}</h3>
        <p className="mt-2 text-sm leading-7 text-foreground-600">{message}</p>
        {children}
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 h-11 rounded-btn bg-background-100 text-foreground-700 text-sm font-semibold hover:bg-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            إلغاء
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`flex-1 h-11 rounded-btn text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap ${confirmClass}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}